import './historico-requisicao-controller';
import './historico-requisicao-consulta-controller';
import './requisicao-form-controller';
